import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getMenu,
  getIdMenu,
  getMenuTree,
  createMenu,
  updateMenu,
  createTree,
  createMenuFav,
  getIdMenuFav,
  getMenuTab,
  deleteMenu,
} from "./menuAPI";
import createTransform from "redux-persist/es/createTransform";

const initialState = {
  dataTab: [],
  data2: [],
  data: [],
  dataModal: [],
  dataId: null,
  dataIdMenuFav: [],
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
  tabMaster : null
};

export const fetchMenu = createAsyncThunk(
  "menu/fetchParameter",
  async (payload) => {
    const response = await getMenu(payload);
    return response;
  }
);
export const fetchMenuTab = createAsyncThunk(
  "menu/fetchMenuTab",
  async (payload) => {
    const response = await getMenuTab(payload);
    return response;
  }
);

export const fetchMenuModal = createAsyncThunk(
  "menu/fetchMenuModal",
  async (payload) => {
    const response = await getMenu(payload);
    return response;
  }
);

export const addMenu = createAsyncThunk(
  "menu/addParameter",
  async (payload) => {
    const response = await createMenu(payload);
    return response;
  }
);

export const addMenuFav = createAsyncThunk(
  "menu/addMenuFav",
  async (payload) => {
    const response = await createMenuFav(payload);
    return response;
  }
);

export const addTree = createAsyncThunk("menu/addTree", async (payload) => {
  const response = await createTree(payload);
  return response;
});

export const editMenu = createAsyncThunk(
  "menu/editParameter",
  async (payload) => {
    const response = await updateMenu(payload);
    return response;
  }
);

export const fetchIdMenu = createAsyncThunk(
  "menu/fetchIdParameter",
  async (id) => {
    const response = await getIdMenu(id);
    return response;
  }
);

export const fetchIdMenuFav = createAsyncThunk(
  "menu/fetchIdMenuFav",
  async (id) => {
    const response = await getIdMenuFav(id);
    return response;
  }
);

export const fetchMenuFavAll = createAsyncThunk(
  "menu/fetchParameter",
  async (payload) => {
    const response = await getMenu(payload);
    return response;
  }
);

export const removeMenu = createAsyncThunk(
  "menu/removeById",
  async (payload) => {
    const response = await deleteMenu(payload);
    return response;
  }
);

export const businessParameterSlice = createSlice({
  name: "menu",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMenu.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMenu.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(fetchMenuTab.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMenuTab.fulfilled, (state, action) => {
        state.loading = false;
        state.dataTab = action.payload.data.data;
      })
      .addCase(fetchMenuModal.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMenuModal.fulfilled, (state, action) => {
        state.loading = false;
        state.dataModal = action.payload.data.data;
      })
      .addCase(fetchIdMenu.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIdMenu.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(fetchIdMenuFav.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIdMenuFav.fulfilled, (state, action) => {
        state.loading = false;
        state.dataIdMenuFav = action.payload.data.data;
      })

      .addCase(addMenu.pending, (state) => {
        state.loading = true;
      })
      .addCase(addMenu.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(editMenu.pending, (state) => {
        state.loading = true;
      })
      .addCase(editMenu.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeMenu.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeMenu.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(addMenuFav.pending, (state) => {
        state.loading = true;
      })
      .addCase(addMenuFav.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const { resetData, setSelected } = businessParameterSlice.actions;

export const selectData = (state) => state.menu.data;
export const selectDataMenuModal = (state) => state.menu.dataModal;
export const selectIdData = (state) => state.menu.dataId;
export const selectIdMenuFav = (state) => state.menu.dataIdMenuFav;
export const selectLoading = (state) => state.menu.loading;
export const selectLoadingMenu = (state) => state.menu.loading;
export const selectError = (state) => state.menu.error;
export const selectPageNo = (state) => state.menu.pageNo;
export const selectPageSize = (state) => state.menu.pageSize;
export const selectTotalRecord = (state) => state.menu.totalRecord;
export const selectSelected = (state) => state.menu.selected;
export const selectResult = (state) => state.menu.result;
export const selectMenuTab = (state) => state.menu.dataTab;

export default businessParameterSlice.reducer;
